// CallsTab -- every 3CX call to/from one customer or lead (any of their
// numbers: site lines, main/cell, sub-contacts), newest first.

import { useEffect, useState } from 'react';
import axios from 'axios';
import CallsTable, { formatSeconds } from './CallsTable.jsx';

export default function CallsTab({ contactId }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setData(null);
    axios.get('/api/calls', { params: { contact_id: contactId, limit: 300 } })
      .then((res) => { if (!cancelled) setData(res.data); })
      .catch((err) => { if (!cancelled) setError(err.response?.data?.error || err.message); });
    return () => { cancelled = true; };
  }, [contactId]);

  if (error) return <p className="calls-error">Could not load calls: {error}</p>;
  if (!data) return <p className="calls-dim">Loading calls…</p>;

  const t = data.totals;
  return (
    <div>
      <div className="calls-tab-summary">
        <span><strong>{t.total}</strong> call{t.total === 1 ? '' : 's'}</span>
        <span><strong>{t.answered}</strong> answered</span>
        <span className={t.missed ? 'calls-result-bad' : ''}><strong>{t.missed}</strong> missed</span>
        {t.unreturned > 0 && <span className="calls-result-bad"><strong>{t.unreturned}</strong> not returned</span>}
        <span><strong>{formatSeconds(t.talk_seconds) || '0s'}</strong> talk time</span>
      </div>
      <CallsTable rows={data.rows} showCaller={false} emptyText="No calls with this account yet." />
    </div>
  );
}
